import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Card, message, Spin } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import './PaymentPage.css';
import { PaymentAPI } from '../../shared/api/conversationService';

interface PaymentPageProps {
  sessionId?: string;
}

const PaymentPage: React.FC<PaymentPageProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  // 从 location state 获取会话 ID
  const sessionId = location.state?.sessionId;
  
  const [loading, setLoading] = useState(false);
  
  // 金额配置
  const amount = 2980; // 2,980日元
  
  useEffect(() => {
    // 如果没有会话ID，重定向到首页
    if (!sessionId) {
      message.error(t('payment.error.noSession'));
      navigate('/');
    }
  }, [sessionId, navigate, t]);
  
  // 创建支付 - 直接使用Stripe支付
  const handleCreatePayment = async () => {
    try {
      setLoading(true);
      
      const paymentData = {
        payment_method: 'card', // 直接使用信用卡支付
        analysis_type: 'standard',
        session_id: sessionId,
        amount_jpy: amount
      };
      
      const response = await PaymentAPI.createPayment(paymentData);
      
      if (response.payment_id && response.payment_url) {
        // 直接重定向到 Stripe Checkout
        window.location.href = response.payment_url;
      } else {
        message.error(t('payment.error.createFailed'));
      }
    } catch (error) {
      console.error('支付创建失败:', error);
      message.error(t('payment.error.createFailed'));
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="payment-page">
      <Card title={t('payment.title')} className="payment-card">
        <div className="payment-amount">
          <h2>{t('payment.amount')}</h2>
          <p className="amount">¥{amount.toLocaleString()}</p>
        </div>
        
        <div className="payment-method">
          <h3>{t('payment.method.title')}</h3>
          <div className="payment-method-info">
            <CreditCardOutlined />
            <span>{t('payment.method.card')}</span>
          </div>
        </div>
        
        {loading ? (
          <div className="payment-loading">
            <Spin />
            <p>{t('payment.loading')}</p>
          </div>
        ) : (
          <Button
            type="primary"
            size="large"
            block
            onClick={handleCreatePayment}
            className="payment-button"
          >
            {t('payment.button')}
          </Button>
        )}
      </Card>
    </div>
  );
};

export default PaymentPage;
